import parseQueryString from "@insite/client-framework/Common/Utilities/parseQueryString";
import {
    replaceInChain
} from "@insite/client-framework/HandlerCreator";
import { chain, ExtractDataFromQueryString, ValidateAmount } from "@insite/client-framework/Store/Pages/CheckoutReviewAndSubmit/Handlers/ValidateAdyenPayment";
// Poolcorp Custom Code - Swapped to the overriden payment service
import { getAdyenPaymentDetails } from "@store/Services/PaymentService";

replaceInChain(chain, ExtractDataFromQueryString, async props => {
    const parsedQuery = parseQueryString<any>(window.location.search);
    if (!parsedQuery.redirectResult) {
        return;
    }

    props.customerId = parsedQuery.customerId;
    props.redirectResult = parsedQuery.redirectResult;

    if (parsedQuery.amount) {
        props.paymentAmount = Number(parsedQuery.amount);
    }

    const paymentDetails = await getAdyenPaymentDetails(parsedQuery.redirectResult);
    if (paymentDetails.amount?.value) {
        props.paymentAmount = paymentDetails.amount.value;
    }
    props.adyenPspReference = paymentDetails.pspReference;
});

replaceInChain(chain, ValidateAmount,  props => {
     // Poolcorp Custom Code - Removed all validate amount logic based on discussion with Adyen. It is not necessary in our scenarios and it does not properly support the feature "increase authorization amount"
});
